import { call, put, takeLatest } from "redux-saga/effects";
import { heApi } from "../../../api/category/heApi";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import { eHeActionTypeIds } from "../../action-types/category/IHeActionType";
import { actions } from "../../actions";

export function* heSaga(): any {
    yield takeLatest(eHeActionTypeIds.LOAD_START, loadWorker)
}
function* loadWorker(): any {
    const res: IBaseRespone = yield call(heApi.getAll)
    if (res.is_success) {
        yield put(actions.he.loadSuccess(res.data))
    } else {
        yield put(actions.he.loadError(res.message))
    }
}